import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {environment} from '@environments/environment';
import {PreferencesPatch, UserPreferences} from '@app/modules/shared/models/navigation';
import {normalizePreferences} from '@app/_helpers/navigation-preferences';

/**
 * The signed-in person's own panel preferences on the server (GET/PUT
 * /api/v1/user/preferences). While impersonating they are the actor's, which the server
 * decides from the session - nothing here names a user. A PUT replaces the keys it sends
 * and answers with the whole result.
 */
@Injectable({providedIn: 'root'})
export class PreferencesService {
  private readonly url = `${environment.apiUrl}/api/v1/user/preferences`;

  constructor(private http: HttpClient) {
  }

  get(): Observable<UserPreferences> {
    return this.http.get<any>(this.url).pipe(map((res) => normalizePreferences(res?.data)));
  }

  update(patch: PreferencesPatch): Observable<UserPreferences> {
    return this.http.put<any>(this.url, patch).pipe(map((res) => normalizePreferences(res?.data)));
  }
}
